<script>
// 不會 Re render
// 用這個 Component 把想要讓他變得可以跟著內容長大的 <textarea /> 包起來．就可以了！
// 固定只長高到 10 行就出現捲軸

export default {
  name: 'AutoResizeField',
  data() {
    return {
      realHeight: 0,
    }
  },
  methods: {
    resize(e) {
      e.target.style.height = 'auto'
      if (e.target.scrollHeight > 240) {
        e.target.style.overflowY = 'scroll'
        e.target.style.height = '240px'
      } else {
        e.target.style.height = e.target.scrollHeight + 'px'
      }
      this.realHeight = e.target.style.height
    },
  },
  mounted() {
    this.$el.addEventListener('input', this.resize)
  },
  beforeDestroy() {
    this.$el.removeEventListener('input', this.resize)
  },
  render() {
    return this.$slots.default[0]
  },
}
</script>

<style></style>
